export enum EELSDetailsTabsUrl {
  DETAILS = 'details',
  CONTACTS = 'contacts',
  ELAC_MEMBERS = 'elac-members',
  ELC_PLACES = 'elc-places',
  MEETINGS = 'meetings',
  RESOURCES = 'resources',
  PILLARS_OF_STRENGTH = 'pillars-of-strength',
  NOTES = 'notes',
  OUTPUT = 'output',
  IN_KIND = 'in-kind',
}
